import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Shield, LogOut } from "lucide-react";

const Logo = () => (
  <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
    <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-violet-500 to-fuchsia-600 flex items-center justify-center shadow-[0_0_16px_rgba(139,92,246,0.5)] group-hover:scale-105 transition-transform">
      <span className="font-serif font-bold text-white text-sm">g</span>
    </div>
    <span className="font-serif font-bold text-lg tracking-tight text-white">grime.bio</span>
  </Link>
);

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="fixed top-4 left-0 right-0 z-50 px-4">
      <div className="max-w-5xl mx-auto flex items-center justify-between rounded-full border border-[#22222B] bg-black/70 backdrop-blur-xl px-4 py-2.5 shadow-2xl">
        <Logo />
        <nav className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
          <a href="#features" className="hover:text-white transition-colors" data-testid="nav-features">Features</a>
          <a href="#premium" className="hover:text-white transition-colors" data-testid="nav-premium">Premium</a>
          <a href="https://discord.gg/zDMTfjWPgg" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="nav-discord">Discord</a>
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button
                  variant="ghost"
                  size="sm"
                  data-testid="nav-admin-btn"
                  onClick={() => navigate("/admin")}
                  className="text-zinc-300 hover:text-white hover:bg-white/5 rounded-full"
                >
                  <Shield className="w-4 h-4 mr-1.5" /> Admin
                </Button>
              )}
              <Button
                variant="ghost"
                size="sm"
                data-testid="nav-dashboard-btn"
                onClick={() => navigate("/dashboard")}
                className="text-zinc-300 hover:text-white hover:bg-white/5 rounded-full"
              >
                <LayoutDashboard className="w-4 h-4 mr-1.5" /> Dashboard
              </Button>
              <Button
                size="sm"
                data-testid="nav-logout-btn"
                onClick={() => { logout(); navigate("/"); }}
                className="bg-white/10 hover:bg-white/20 text-white rounded-full"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                size="sm"
                data-testid="nav-login-btn"
                onClick={() => navigate("/login")}
                className="text-zinc-200 hover:text-white hover:bg-white/5 rounded-full px-4"
              >
                Login
              </Button>
              <Button
                size="sm"
                data-testid="nav-register-btn"
                onClick={() => navigate("/register")}
                className="bg-violet-600 hover:bg-violet-500 text-white rounded-full px-4 shadow-[0_0_20px_rgba(139,92,246,0.4)]"
              >
                Register
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
